import React from 'react';
import './Contain.css';

const propTypes = {
  children: React.PropTypes.oneOfType([
    React.PropTypes.array,
    React.PropTypes.object
  ]),
  size: React.PropTypes.oneOf([
    'sm'
  ])
}

const Contain = props => (
  <div className={`l-contain ${props.size ? 'l-contain--' + props.size : ''}`}>
    {props.children}
  </div>
)

Contain.propTypes = propTypes;

export default Contain;



// WEBPACK FOOTER //
// ./src/layout/Contain/Contain.js